import type { MapViewState } from "@deck.gl/core";
import type { Deck } from "@deck.gl/core";
import type { MapLayerState } from "@/types/stores/map";

const DEFAULT_VIEW_STATE: MapViewState = {
  longitude: 11,
  latitude: 56,
  zoom: 4,
  pitch: 0,
  bearing: 0,
};

export function createMapInstanceActions(
  set: any,
  get: () => MapLayerState
) {
  return {
    setMapInstance: (workspaceId: string, deck: Deck | null, viewState?: MapViewState) => {
      const state = get();
      if (deck === null) {
        const newInstances = { ...state.mapInstances };
        delete newInstances[workspaceId];
        set({ mapInstances: newInstances }, false, "map/setMapInstance");
      } else {
        const existingInstance = state.mapInstances[workspaceId];
        const newInstances = {
          ...state.mapInstances,
          [workspaceId]: {
            deck,
            viewState:
              viewState || existingInstance?.viewState || DEFAULT_VIEW_STATE,
            isLoaded: existingInstance?.isLoaded || false,
          },
        };
        set({ mapInstances: newInstances }, false, "map/setMapInstance");
      }
    },

    getMapInstance: (workspaceId: string) => {
      return get().mapInstances[workspaceId]?.deck || null;
    },

    getViewState: (workspaceId: string) => {
      return get().mapInstances[workspaceId]?.viewState || null;
    },

    setViewState: (workspaceId: string, viewState: MapViewState) => {
      const state = get();
      if (state.mapInstances[workspaceId]) {
        const newInstances = {
          ...state.mapInstances,
          [workspaceId]: {
            ...state.mapInstances[workspaceId],
            viewState,
          },
        };
        set({ mapInstances: newInstances }, false, "map/setViewState");
      }
    },

    removeMapInstance: (workspaceId: string) => {
      const state = get();
      const newInstances = { ...state.mapInstances };
      delete newInstances[workspaceId];
      set({ mapInstances: newInstances }, false, "map/removeMapInstance");
    },

    setMapLoaded: (workspaceId: string, isLoaded: boolean) => {
      const state = get();
      if (state.mapInstances[workspaceId]) {
        const newInstances = {
          ...state.mapInstances,
          [workspaceId]: {
            ...state.mapInstances[workspaceId],
            isLoaded,
          },
        };
        set({ mapInstances: newInstances }, false, "map/setMapLoaded");
      }
    },

    setActiveWorkspace: (workspaceId: string | null) => {
      set(
        { activeWorkspaceId: workspaceId },
        false,
        "map/setActiveWorkspace"
      );
    },
  };
}

